import { render, staticRenderFns } from "./role-form.vue?vue&type=template&id=4811fb1a"
import script from "./role-form.vue?vue&type=script&lang=js"
export * from "./role-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports